import React, { useEffect, useState } from "react";
import Button from "../../components/Button/Button";
import Slab from "../../components/Slab/Slab";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { GetFanPublicDetails } from "../../services/fanPublic.service";
import { handleDate } from "../../utils/formatdate";

const FanPublic: React.FC = () => {
  const { username } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const fan_id = location.state?.fan_id;
  const [state, setState] = useState({
    isLoading: false,

    public_details: {
      id: "",
      username: "",
      first_name: "",
      last_name: "",
      public_bio: "",
      user_profile_url: "",
    },
    fan_memberships: [] as {
      product_id: "";
      public_id: "";
      product_name: "";
      price: "";
      image_url: "";
      expire_date: "";
    }[],
    twitter_username: "",
    instagram_username: "",
  });

  const handleToggle = (key: keyof typeof state, value: boolean) => {
    setState((prev) => ({ ...prev, [key]: value }));
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        handleToggle("isLoading", true);
        const res = await GetFanPublicDetails(username);
        const { public_details, membership_details, social_connections } = res.data;
        // Update the state
        setState((prev) => ({
          ...prev,
          public_details: {
            id: public_details.id,
            username: public_details.username,
            first_name: public_details.first_name,
            last_name: public_details.last_name,
            public_bio: public_details.public_bio,
            user_profile_url: public_details.user_profile_url,
          },
          fan_memberships:
            membership_details &&
            membership_details.map((membership: any) => ({
              product_id: membership.entity_id,
              public_id : membership.public_id,
              product_name: membership.entity_name,
              price: membership.price.toString(), // Convert price to string if required
              image_url: membership.image_url,
              expire_date: handleDate(membership.expire_date),
            })),
          twitter_username: social_connections?.find((conn: { connection_id: string; }) => conn.connection_id === "twitter")?.connection_user_name || null,
          instagram_username: social_connections?.find((conn: { connection_id: string; }) => conn.connection_id === "instagram")?.connection_user_name || null
        }));
      } catch {
        console.error("Failed to fetch fan details.");
      } finally {
        handleToggle("isLoading", false);
      }
    };
    fetchData();
    //eslint-disable-next-line
  }, [fan_id]);

  return (
    <>
      {state.isLoading ? (
        <div className="loader">
          <div className="spinner"></div>
        </div>
      ) : (
        <></>
      )}
      <div className="container fan-public-page">
        <div className="edit-profile-header my-4 mx-2">
          @{state.public_details.username}
        </div>

        <div className="mobile">
          <div className="fan-data d-flex">
            <div className="fan-img">
              {state.public_details.user_profile_url !== null ? (
                <img
                  src={state.public_details.user_profile_url}
                  alt={state.public_details.username}
                  className="img-fluid user-image"
                />
              ) : (
                // <div className="position-relative bg-extra-light-purple img mx-auto d-flex align-items-center">
                <div className="w-100 bg-extra-light-purple user-image d-flex justify-content-center align-items-center">
                  <i className="fa-regular fa-user font-100-30 text-dark"></i>
                </div>
                // </div>
              )}
            </div>
            <div className="fan-img-data">
              <div className="name">@{state.public_details.username}</div>
            </div>
          </div>
        </div>
        <div className="row px-0 mx-0 public-fan">
          <div className="left col-lg-3 col-12 mx-2">
            <div className="public-profile my-4 pt-3">
              {state.public_details.user_profile_url !== null ? (
                <div className="position-relative img mx-auto">
                  <img
                    src={state.public_details.user_profile_url}
                    alt={state.public_details.first_name}
                    className="img-fluid user-image"
                  />
                </div>
              ) : (
                <div className="position-relative bg-extra-light-purple img mx-auto d-flex align-items-center">
                  <div className="w-100">
                    <i className="fa-regular fa-user font-100-60 text-dark"></i>
                  </div>
                </div>
              )}

              <div className="p-4 text-start">
                <div className="row mb-2">
                  <div className="col-12 font-inter-500-15 line-21">
                    Full Name
                  </div>
                  <div className="col-12 extra-light-purple font-inter-300-15 line-21">
                    {state.public_details.first_name}{" "}
                    {state.public_details.last_name}
                  </div>
                </div>
                {/* <div className="row mb-2">
                  <div className="col-12 font-inter-500-15 line-21">
                    <i className="fa-brands fa-x-twitter me-1 font-400 font-15"></i>
                    Twitter
                  </div>
                  <div className="col-12 purple-color font-inter-300-15 line-21">
                    {state.twitter_username ? <> @{state.twitter_username}</> : "---"}
                  </div>
                </div>
                <div className="row mb-2">
                  <div className="col-12 font-inter-500-15 line-21">
                    <i className="fa-brands fa-instagram me-1 font-400 font-15"></i>
                    Instagram
                  </div>
                  <div className="col-12 purple-color font-inter-300-15 line-21">
                    {state.instagram_username ? <> @{state.instagram_username}</> : "---"}
                  </div>
                </div> */}
                <div className="row mb-3">
                  <div className="col-12 font-inter-500-15 line-21">About</div>
                  <div className="col-12 extra-light-purple font-inter-300-15 line-21">
                    {state.public_details.public_bio}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="right py-4 col-lg col-12">
            <div className="mb-3 font-500-30 heading">Memberships</div>
            <div className="fan-membership">
                {state.fan_memberships && state.fan_memberships.length > 0 ? (
                  <div>
                    {state.fan_memberships.map((item) => (
                      <Slab
                        key={item.product_id}
                        className="mb-3"
                        content={
                          <div className="d-flex membership-slab w-100">
                            <img
                              src={item.image_url}
                              alt="Membership title1"
                              className="members-img"
                            />
                            <div className="content">
                              <Link
                              to={{
                                  pathname: `/${item.public_id}`,
                                }}
                                state={{ id: item.product_id }}
                              className="text-decoration-none font-400 font-18 col text-light-purple my-auto"
                            >
                                {item.product_name}
                              </Link>

                              <div className="d-flex col-lg-5 col my-auto justify-content-around">
                                <div className="d-flex">
                                  <div className="font-inter-400-14">Value:</div>
                                  <div className="font-inter-400-14 ms-1 extra-light-purple">
                                    ${item.price}
                                  </div>
                                </div>
                                <div className="d-flex">
                                  <div className="font-inter-400-14">
                                  Available:
                                </div>
                                  <div className="font-inter-400-14 ms-1 extra-light-purple">
                                    {item.expire_date}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        }
                      />
                    ))}
                  </div>
                ) : (
                  <div
                    className="membership-tile box-custom"
                    style={{ position: "relative", overflow: "hidden" }}
                  >
                    <div className="text-center null-content z-1">
                      <div className="font-500-30 white-color mb-1">
                        @{state.public_details.username} <br />
                        has no memberships yet!
                      </div>
                      <div className="font-500-20 py-4">
                        Find your next membership
                      </div>
                      <Button
                        label="Go to Rankings"
                        className="mb-2 button"
                        onClick={() => navigate("/rankings")}
                        variant="dark"
                      />
                    </div>

                  {/* Bottom-right blurred effect */}
                  <div className="bottom-center-blur-effect" />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FanPublic;
